import { render, staticRenderFns } from "./StatusConfig.vue?vue&type=template&id=45d732aa&scoped=true&"
import script from "./StatusConfig.vue?vue&type=script&lang=js&"
export * from "./StatusConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d732aa",
  null
  
)

export default component.exports